import { MapElementFactory } from "vue2-google-maps";

export default MapElementFactory({
  name: "directionsRenderer",

  ctr() {
    return window.google.maps.DirectionsRenderer;
  },

  events: [],

  mappedProps: {},

  props: {
    origin: { type: Object },
    destination: { type: Object },
    waypoints: { type: Array },
    travelMode: { type: String }
  },

  afterCreate(directionsRenderer) {
    let directionsService = new window.google.maps.DirectionsService();

    directionsRenderer.setOptions({ 
      suppressMarkers: true
 });

    this.$watch(
      () => [this.origin, this.destination, this.waypoints, this.travelMode],
      () => {
        let { origin, destination, waypoints, travelMode } = this;
        if (!origin || !destination || !waypoints || !travelMode) return;

        directionsService.route(
          {
            origin,
            destination,
            waypoints,
            optimizeWaypoints: true,
            travelMode
          },
          (response, status) => {
            if (status !== "OK") return;
            directionsRenderer.setDirections(response);
            console.log("response sotto");
            console.log(response);

            this.$emit('onDirection', response?.routes?.[0]?.overview_path);
            
          }
        );
      }
    );
  }
});
